/*
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import PropTypes from 'prop-types'

const AddOnInput = ({ addOn, label, ...props }) => {
  return (
    <div>
      <label
        htmlFor="company-website"
        className="sr-only text-sm font-medium text-v8-ink"
      >
        {label}
      </label>
      <div className="mt-1 flex rounded-md shadow-sm">
        <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-v8-line bg-v8-paper text-v8-mut sm:text-sm">
          {addOn}
        </span>
        <input
          {...props}
          className="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-r-md focus:ring-v8-blue focus:border-v8-blue sm:text-sm border-v8-line"
        />
      </div>
    </div>
  )
}

AddOnInput.propTypes = {
  label: PropTypes.string,
  addOn: PropTypes.string,
}
export default AddOnInput
